import { IYantrasColumn } from "../../entities/yantras/yantraCards";
import { ICardsState, IRequestBody } from "./CardsStore";

const addColumnCards = (state: ICardsState, rowIndex: number): Partial<ICardsState> => {
  const columnCards = state.yantrasColumns[rowIndex].cards.map((card) => card.id);
  const updatedCardIds = { ...state.cardIds };

  columnCards.forEach((cardId) => {
    cardId in updatedCardIds ? (updatedCardIds[cardId] += 1) : (updatedCardIds[cardId] = 1);
  });

  return { cardIds: updatedCardIds };
};

const removeColumnCards = (state: ICardsState, columnIndex: number): Partial<ICardsState> => {
  const columnCards = state.yantrasColumns[columnIndex].cards.map((card) => card.id);
  const updatedCardIds = { ...state.cardIds };

  columnCards.forEach((cardId) => {
    if (cardId in updatedCardIds) {
      delete updatedCardIds[cardId];
    }
  });

  return { cardIds: updatedCardIds };
};

const isCardInActiveColumn = (state: ICardsState, cardId: string): boolean => {
  return state.activeColumn.some((column) =>
    state.yantrasColumns[column].cards.some((card) => card.id === cardId)
  );
};

const getActiveColumnIndex = (state: ICardsState, cardId: string): number => {
  return (
    state.activeColumn.find((column) =>
      state.yantrasColumns[column].cards.some((card) => card.id === cardId)
    ) ?? -1
  );
};

const setHistory = (history: IRequestBody[], requestBody: IRequestBody) => {
  const newHistory = [...history, { ...requestBody }];
  const newHistoryIndex = newHistory.length - 1;
  return { newHistory, newHistoryIndex };
};

const getCardsFromRows = (
  updatedRows: Record<string, number>,
  yantrasColumns: IYantrasColumn[]
) => {
  const rowKeys = Object.keys(updatedRows);
  const cardsFromRows: Record<string, number> = {};
  rowKeys.forEach((key) => {
    yantrasColumns[Number(key)].cards.forEach((card) => {
      cardsFromRows[card.id] = updatedRows[key];
    });
  });
  return cardsFromRows;
};

export {
  addColumnCards,
  removeColumnCards,
  isCardInActiveColumn,
  setHistory,
  getActiveColumnIndex,
  getCardsFromRows,
};
